/* Cérène theme — global JS */

document.addEventListener('DOMContentLoaded', function () {
  // Popup modal
  var modal = document.getElementById('cerene-popup');
  if (modal) {
    var openers = document.querySelectorAll('[data-open-popup]');
    openers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); modal.classList.add('open'); }); });
    var closers = modal.querySelectorAll('[data-close-popup]');
    closers.forEach(function (c) { c.addEventListener('click', function () { modal.classList.remove('open'); }); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('open'); });
    // Auto-open once per session
    setTimeout(function () {
      try {
        if (!sessionStorage.getItem('cerene-popup')) {
          modal.classList.add('open');
          sessionStorage.setItem('cerene-popup', '1');
        }
      } catch (e) {}
    }, 1500);
  }
});


/* === Enhanced theme JS === */
(function () {
  // PDP accordion
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.pdp-acc-head, .faq-q');
    if (!head) return;
    var item = head.closest('.pdp-acc-item, .faq-item');
    if (item) item.classList.toggle('open');
  });

  // PDP gallery thumbnail switching
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp-thumb');
    if (!thumb) return;
    var src = thumb.dataset.full;
    var main = document.querySelector('.pdp-main img');
    if (main && src) main.src = src;
    document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  // PDP variant selector
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.pdp-option');
    if (!opt || opt.classList.contains('unavailable')) return;
    var group = opt.closest('.pdp-option-group');
    if (group) {
      group.querySelectorAll('.pdp-option').forEach(function (o) { o.classList.remove('active'); });
      opt.classList.add('active');
      var hidden = group.querySelector('input[type=hidden]');
      if (hidden) hidden.value = opt.dataset.value;
    }
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-qty button, .qty-input button');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (btn.dataset.action === 'inc') input.value = val + 1;
    if (btn.dataset.action === 'dec' && val > 1) input.value = val - 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Filter sidebar toggle
  var filterBtn = document.querySelector('.filter-toggle');
  var filterSidebar = document.querySelector('.coll-filters');
  if (filterBtn && filterSidebar) {
    filterBtn.addEventListener('click', function () { filterSidebar.classList.toggle('open'); });
  }
})();
